import {appConfig as environmentInfo} from "./environment/environments";

export const appConfig = {
    // uiUrl: "https://dev-eDesign.carrier.com/licenseManager", old uiUrl since 11/14/2024
    uiUrl: environmentInfo.uiUrl,
    apiUrl: environmentInfo.apiUrl,
    postLogOutUri: environmentInfo.postLogOutUri //For Dev only
  };
export default appConfig;
